(function($) {

    'use strict'

	var alertsCarousel = function() {
		$('.alertsCarousel').owlCarousel({
			items: 1,
			autoplay: true,
			autoplayTimeout: 15000,
			loop: true,
			dots: true,
			autoHeight: false,
			smartSpeed: 600,
		})

		var dots = document.getElementsByClassName('owl-dot');

		if(dots){
			for (let i = 0; i < dots.length; i++) {
				console.log(dots[i]);
				dots[i].ariaLabel = "Slide "+i;
				}
		}		
	};

	$(document).ready(function() {
		if($('.alertsCarousel').length) {
			alertsCarousel()
		}
	})

})(jQuery)